import { t } from "i18next";
import { useState } from "react";
import { useVisitWrites } from "@/hooks/visits/useVisitWrites";
import { getVisitTitle } from "@/lib/utils";
import type { VisitSummary } from "@/services/files";

type VisitAction =
  | { kind: "deleted"; visitTitle: string }
  | { kind: "changeTitle"; visitTitle: string; newTitle: string };
export const useVisitActions = () => {
  const { updateVisit, deleteVisit, result, loading, error } = useVisitWrites();
  const [action, setAction] = useState<VisitAction | null>(null);
  return {
    deleteVisitByFile: (
      file: Pick<VisitSummary, "public_id" | "title" | "rowno">,
    ): Promise<boolean> => {
      setAction({
        kind: "deleted",
        visitTitle: getVisitTitle(file.title, file.rowno),
      });
      return deleteVisit({
        params: { public_id: String(file.public_id) },
        query: {},
      });
    },
    changeTitleVisitByFile: (
      file: Pick<VisitSummary, "public_id" | "title" | "rowno">,
      title: string,
    ): Promise<boolean> => {
      setAction({
        kind: "changeTitle",
        visitTitle: getVisitTitle(file.title, file.rowno),
        newTitle: title,
      });
      return updateVisit({
        params: { public_id: String(file.public_id) },
        query: {},
        body: { title },
      });
    },
    result:
      result && action
        ? t(`visits.actions.messages.${action.kind}Success`, action)
        : null,
    loading,
    error:
      error && action ? t(`visits.actions.messages.${action.kind}Error`) : null,
  };
};
